export default  [
				{
          path: '',
          component: () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-post.vue'),
          meta: { userTopbar: true, noBottombarsMobile: true }
        },
        {
          path: 'saved/',
          component: () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-saved.vue'),
          meta: { userTopbar: true, noBottombarsMobile: true }
        },
        {
          path: 'tagged/',
          component: () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-tagged.vue'),
          meta: { userTopbar: true, noBottombarsMobile: true }
        },
        {
          path: 'following/',
          components: {
            default: () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-post.vue'),
            'dialog': () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-following.vue')
          },
          meta: { userTopbar: true, noBottombarsMobile: true }
        },

        {
          path: 'followers/',
          components: {
            default: () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-post.vue'),
            'dialog': () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-followers.vue')
          },
          meta: { userTopbar: true, noBottombarsMobile: true }
        },

        {
          path: 'rate/',
          components: {
            default: () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-post.vue'),
            'dialog': () => import( /* webpackChunkName: "profile" */ '../../components/profile/profile-rate.vue')
          },
          meta: { userTopbar: true, noBottombarsMobile: true }
        }
 ]